<!-- Copyright (c) ArubaCC - All Rights Reserved. -->
<div class="flex">
  @if (news) {
    <div
      class="rounded-3xl py-1 px-2 border-2 flex items-center whitespace-nowrap text-sm"
      [class.border-green]="news.serviceType === eNewsCategory.PEC"
      [class.border-orange]="news.serviceType === eNewsCategory.FEL"
      >
      {{ news.category }}
    </div>
  }
</div>
